/**
 * @format
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';
import { SisCommonModule } from 'sis-common';
import {
    alertsServiceProvider,
    AttainmentApplicationStructureModule,
    ModuleAttainmentApplicationModule,
    SisComponentsHybridModule,
    StudyRightModule,
} from 'sis-components';
import { StudentCommonModule } from '../../common/common.module';
import { ApplicationModalService } from './application-modal.service';
import { registerApplicationDiscardConfirmationHook, studentApplicationStates } from './applications.route-ng';
import { CancelWorkflowDialogComponent } from './cancel-workflow-dialog/cancel-workflow-dialog.component';
import { AddPriorLearningModalComponent } from './create/add-prior-learning-modal/add-prior-learning-modal.component';
import { ApplicationAttachmentsComponent } from './create/application-attachments/application-attachments.component';
import { AttachmentsPreviewComponent } from './create/attachments-preview/attachments-preview.component';
import { CustomAttainmentApplicationSupplementWizardComponent } from './create/custom-attainment-application-supplement-wizard/custom-attainment-application-supplement-wizard.component';
import { CustomAttainmentBasicInfoEditComponent } from './create/custom-attainment-basic-info-edit/custom-attainment-basic-info-edit.component';
import { CaaAttainmentInfoComponent } from './create/custom-attainment-workflow-application-wizard/caa-attainment-info/caa-attainment-info.component';
import { CaaConfirmationComponent } from './create/custom-attainment-workflow-application-wizard/caa-confirmation/caa-confirmation.component';
import { CustomAttainmentWorkflowApplicationWizardComponent } from './create/custom-attainment-workflow-application-wizard/custom-attainment-workflow-application-wizard.component';
import { CreateExtensionApplicationComponent } from './create/extension-application/create-extension-application.component';
import { ExtensionApplicationStudyProgressAndPlanInfoComponent } from './create/extension-application/extension-application-study-progress-and-plan-info/extension-application-study-progress-and-plan-info.component';
import { StudyRightExtensionApplicationFormComponent } from './create/extension-application/study-right-extension-application-form/study-right-extension-application-form.component';
import { StudyRightExtensionApplicationPayerDetailsComponent } from './create/extension-application/study-right-extension-application-payer-details/study-right-extension-application-payer-details.component';
import { StudyRightExtensionApplicationPreviewComponent } from './create/extension-application/study-right-extension-application-preview/study-right-extension-application-preview.component';
import { PaymentStartedWarningComponent } from './create/payment-started-warning-dialog/payment-started-warning-dialog.component';
import { PlanModuleSelectorComponent } from './create/plan-module-selector/plan-module-selector.component';
import { PriorCompetenceEditComponent } from './create/prior-learning-and-attachments-edit/prior-competence-edit/prior-competence-edit.component';
import { PriorLearningAndAttachmentsEditComponent } from './create/prior-learning-and-attachments-edit/prior-learning-and-attachments-edit.component';
import { PriorStudiesEditComponent } from './create/prior-learning-and-attachments-edit/prior-studies-edit/prior-studies-edit.component';
import { PriorLearningApplicationConfirmationComponent } from './create/prior-learning-application-confirmation/prior-learning-application-confirmation.component';
import { PriorLearningInclusionWorkflowApplicationWizardComponent } from './create/prior-learning-inclusion-workflow-application-wizard/prior-learning-inclusion-workflow-application-wizard.component';
import { PriorLearningInclusionWorkflowSupplementWizardComponent } from './create/prior-learning-inclusion-workflow-supplement-wizard/prior-learning-inclusion-workflow-supplement-wizard.component';
import { PriorLearningSubstitutionWorkflowApplicationWizardComponent } from './create/prior-learning-substitution-workflow-application-wizard/prior-learning-substitution-workflow-application-wizard.component';
import { PriorLearningSubstitutionWorkflowSupplementWizardComponent } from './create/prior-learning-substitution-workflow-supplement-wizard/prior-learning-substitution-workflow-supplement-wizard.component';
import { SelectEmrexAttainmentDialogComponent } from './create/select-emrex-attainment-dialog/select-emrex-attainment-dialog.component';
import { CustomAttainmentWorkflowSummaryComponent } from './custom-attainment-workflow/custom-attainment-workflow-summary/custom-attainment-workflow-summary.component';
import { CustomAttainmentWorkflowComponent } from './custom-attainment-workflow/custom-attainment-workflow.component';
import { DegreeCertificateDownloadComponent } from './degree-certificate-download/degree-certificate-download.component';
import { DegreeProgrammeAttainmentWorkflowComponent } from './degree-programme-attainment-workflow/degree-programme-attainment-workflow.component';
import { ModuleAttainmentApplicationComponent } from './module-attainment-application/module-attainment-application.component';
import { ModuleContentWorkflowSummaryComponent } from './module-content-workflow/module-content-workflow-summary/module-content-workflow-summary.component';
import { ModuleContentWorkflowComponent } from './module-content-workflow/module-content-workflow.component';
import { WorkflowCancellationInfoModalComponent } from './module-content-workflow/workflow-cancellation-info-modal/workflow-cancellation-info-modal.component';
import { PriorLearningWorkflowContentComponent } from './prior-learning-workflow-content/prior-learning-workflow-content.component';
import { PriorLearningWorkflowComponent } from './prior-learning-workflow/prior-learning-workflow.component';
import { StudentApplicationsComponent } from './student-applications/student-applications.component';
import { StudyRightExtensionWorkflowCeeposConfirmationComponent } from './study-right-extension-workflow/ceepos-confirmation/study-right-extension-workflow-ceepos-confirmation.component';
import { StudyRightExtensionWorkflowPaymentFailedComponent } from './study-right-extension-workflow/payment-failed/study-right-extension-workflow-payment-failed.component';
import { StudyRightExtensionWorkflowPaymentProcessingComponent } from './study-right-extension-workflow/payment-processing/study-right-extension-workflow-payment-processing.component';
import { StudyRightExtensionWorkflowPaytrailConfirmationComponent } from './study-right-extension-workflow/paytrail-confirmation/study-right-extension-workflow-paytrail-confirmation.component';
import { StudyRightExtensionWorkflowDecisionSummaryComponent } from './study-right-extension-workflow/study-right-extension-workflow-decision-summary/study-right-extension-workflow-decision-summary.component';
import { StudyRightExtensionWorkflowSummaryComponent } from './study-right-extension-workflow/study-right-extension-workflow-summary/study-right-extension-workflow-summary.component';
import { StudyRightExtensionWorkflowComponent } from './study-right-extension-workflow/study-right-extension-workflow.component';
import { WorkflowStateBadgeComponent } from './workflow-state-badge/workflow-state-badge.component';

@NgModule({
    declarations: [
        AddPriorLearningModalComponent,
        AttachmentsPreviewComponent,
        CaaAttainmentInfoComponent,
        CaaConfirmationComponent,
        CustomAttainmentWorkflowApplicationWizardComponent,
        CustomAttainmentBasicInfoEditComponent,
        CustomAttainmentApplicationSupplementWizardComponent,
        ModuleAttainmentApplicationComponent,
        PlanModuleSelectorComponent,
        PriorCompetenceEditComponent,
        PriorLearningAndAttachmentsEditComponent,
        PriorLearningApplicationConfirmationComponent,
        PriorLearningInclusionWorkflowApplicationWizardComponent,
        PriorLearningSubstitutionWorkflowApplicationWizardComponent,
        PriorStudiesEditComponent,
        PriorLearningWorkflowContentComponent,
        ModuleContentWorkflowSummaryComponent,
        ModuleContentWorkflowComponent,
        WorkflowCancellationInfoModalComponent,
        WorkflowStateBadgeComponent,
        PriorLearningSubstitutionWorkflowSupplementWizardComponent,
        PriorLearningInclusionWorkflowSupplementWizardComponent,
        ApplicationAttachmentsComponent,
        StudentApplicationsComponent,
        CreateExtensionApplicationComponent,
        ExtensionApplicationStudyProgressAndPlanInfoComponent,
        StudyRightExtensionApplicationFormComponent,
        StudyRightExtensionApplicationPreviewComponent,
        StudyRightExtensionApplicationPayerDetailsComponent,
        DegreeProgrammeAttainmentWorkflowComponent,
        DegreeCertificateDownloadComponent,
        CancelWorkflowDialogComponent,
        PaymentStartedWarningComponent,
        CustomAttainmentWorkflowComponent,
        PriorLearningWorkflowComponent,
        SelectEmrexAttainmentDialogComponent,
        CustomAttainmentWorkflowSummaryComponent,
        StudyRightExtensionWorkflowComponent,
        StudyRightExtensionWorkflowCeeposConfirmationComponent,
        StudyRightExtensionWorkflowPaytrailConfirmationComponent,
        StudyRightExtensionWorkflowPaymentFailedComponent,
        StudyRightExtensionWorkflowPaymentProcessingComponent,
        StudyRightExtensionWorkflowSummaryComponent,
        StudyRightExtensionWorkflowDecisionSummaryComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SisCommonModule,
        SisComponentsHybridModule,
        TranslateModule.forChild(),
        UIRouterModule.forChild({
            states: studentApplicationStates,
            config: (uiRouter, injector) => registerApplicationDiscardConfirmationHook(uiRouter, injector),
        }),
        ModuleAttainmentApplicationModule,
        AttainmentApplicationStructureModule,
        NgxFudisModule,
        StudyRightModule,
    ],
    providers: [StudentCommonModule, ApplicationModalService, alertsServiceProvider],
})
export class ApplicationsModule {}
